/* eslint-disable prettier/prettier */
import React from "react";

const WipDelay = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.648 11.6575L8.84797 3.37592C8.68155 3.08154 8.34877 2.90234 8.00315 2.90234C7.65753 2.90234 7.33753 3.08154 7.15833 3.38877L2.35833 11.6576C2.1919 11.9519 2.20476 12.336 2.35833 12.6303C2.52476 12.9247 2.87028 13.1168 3.20315 13.1168H12.8032C13.1359 13.1168 13.4816 12.9248 13.648 12.6303C13.8015 12.3487 13.8143 11.9647 13.648 11.6576V11.6575ZM3.47198 12.0159L8.00318 4.18232V4.19509L12.5344 12.0159L3.47198 12.0159Z"
      fill="#961B01"
    />
    <path
      d="M8.93657 11.8111H12.1878L11.0358 9.82705C10.6774 9.99348 10.4726 10.3006 10.2806 10.5567L8.97502 9.80152L8.38627 7.5743C8.36064 7.44626 8.23269 7.30545 8.09189 7.24152C8.0535 7.21589 7.98948 7.20312 7.95108 7.20312H6.93993C6.78636 7.20312 6.68395 7.27991 6.60715 7.40795L6.14635 8.17599C6.06957 8.3168 6.12073 8.52161 6.22314 8.56001L6.83752 8.91841L6.81189 8.94404C6.74787 9.07208 6.79912 9.25126 6.90153 9.31519L8.21993 10.0448V11.4656C8.21993 11.6192 8.33511 11.7345 8.48878 11.7345C8.56557 11.7345 8.64235 11.7089 8.6936 11.6448C8.74476 11.5937 8.77039 11.5297 8.77039 11.4656L8.7703 10.0447L10.0759 10.7998C9.78154 11.0687 9.46154 10.9406 9.21832 11.1966C9.09028 11.363 8.98787 11.5806 8.93663 11.8111L8.93657 11.8111ZM7.0038 8.64947L6.5814 8.40625L7.0038 7.68947H7.5414L7.0038 8.64947ZM7.77184 9.11027L8.13024 8.48305L8.39909 9.46867L7.77184 9.11027Z"
      fill="#961B01"
    />
    <path
      d="M8.70689 7.48443C9.00127 7.48443 9.16769 7.24121 9.16769 6.92121C9.16769 6.63961 8.9501 6.44763 8.70689 6.40925C8.68127 6.40925 8.64287 6.39648 8.61725 6.39648C8.33565 6.39648 8.24609 6.65246 8.24609 6.97246C8.24609 7.29246 8.42529 7.48441 8.70689 7.48441L8.70689 7.48443Z"
      fill="#961B01"
    />
    <path
      d="M7.41534 9.75075L6.82658 9.41797L6.90337 9.82761C6.91614 9.91726 6.96739 10.0965 6.90337 10.186L6.12257 11.2996C6.04578 11.4148 6.08417 11.6068 6.18659 11.6836C6.34016 11.7988 6.53221 11.6708 6.57061 11.6196L7.40256 10.4292C7.42819 10.3781 7.49221 10.1989 7.46658 10.0325C7.47935 10.0196 7.44096 9.75077 7.41533 9.75077L7.41534 9.75075Z"
      fill="#961B01"
    />
  </svg>
);

export default WipDelay;
